"use client";
import { Card, Carousel, Typography } from "antd";
import Image from "next/image";
import React, { useEffect, useRef } from "react";
import { useIntl } from "react-intl";
// import { searchState } from "../cmp/state/atoms";
// import { updateRecoilState, useRecState } from "../events/Recoil";
// import { KeyCloakService } from "../oid/KeyCloak";
// import { calendarState } from "../recoil/calendarAtom";
// import bookingService from "../services/bookingService";
// import { userCustomerService } from "../services/customerService";
// import { manageWidgetService } from "../services/manageWidgetService";
// import { ManageWidgetItem } from "../types/WidgetsReqAndRes";
import { KeyCloakService } from "../../Auth/KeyCloak";
import Download from "../../Components/Download/Download";
import HelpInfo from "../../Components/HelpInfo/HelpInfo";
import SaleCard from "../../Components/HyperSales/SaleCard";
import NewsWidget from "../../Components/LandingPage/NewsWidget/NewsWidget";
import PopularDestinationWidget from "../../Components/LandingPage/PopularDestinationWidget/PopularDestinationWidget";
import RoutesWidget from "../../Components/LandingPage/RoutesWidget/RoutesWidget";
import SearchComponent from "../../Components/LandingPage/SearchComponent/SearchComponent";
import Section from "../../Components/Section/Section";
import TrustBuilderWidget from "../../Components/TrustBuilderWidget/TrustBuilderWidget";
import { _eventBus } from "../../core/events/EventBus";
import { FlowRunner } from "../../core/flows/FlowRunner";
import { requestCorporateAccountFlow } from "../../Flows/CorporateAccount/RequestCorporateAccount/MainBookingFlow/RequestCorporateAccountFlow";
import { bookItAgainTree } from "../../Orchestrator/ConstantTree/BookItAgain/BookItAgainTree";
import { corporateAccountTree } from "../../Orchestrator/ConstantTree/CorporateAccount/CorporateAccountTree";
import { UserProfile } from "../../Orchestrator/Recoils/atoms";
import { updateRecoilState, useRecState } from "../../Orchestrator/Recoils/Events/Recoil";
import "./style.css";
// import { IRequestCorporateAccount } from "../../Orchestrator/Types/Interface/IRequestCorporate";
// import { homePageMainStartupFlowExecute } from "../../Flows/HomePage/HomePageStartup";
// import { homePageStartFlow } from "../../Flows/Common/Search/SearchStartupFlow";
import ImageSlider from "../../Components/LandingPage/ImageSlider/ImageSlider";
import { IManageWidgetItem } from "../../Orchestrator/Types/Interface/IWidgetsReqAndRes";
import { fetchWidgetsAction } from "../../Actions/LogicActions/MyAccount/PersonalizeExperience/FetchWidgetsAction";
import { fetchFavouriteDeparturesBestPricesAction } from "../../Actions/LogicActions/Search/FetchFavouriteDeparturesBestPricesAction";
import { getFavouriteTripsForTodayAction } from "../../Actions/LogicActions/Search/GetFavouriteTripsForTodayAction";
import { getPopularTripsAction } from "../../Actions/LogicActions/Search/GetPopularTripsAction";
import { getCMSEnhancedTripsAction } from "../../Actions/LogicActions/CMSEnhancedTrips/GetCMSEnhancedTripsAction";
import { getCmsUsefulInformationAction } from "../../Actions/LogicActions/Search/GetUsefulInformationAction";
import { appStore } from "../../Orchestrator/Recoils/store";
import { manageIncludeWidgetsAtom } from "../../Orchestrator/Recoils/MyAccount";
import FavouriteTrips from "../../Components/EnhanceYourTrip/FavouriteTrips";
import EnhanceYourTrip from "../../Components/EnhanceYourTrip/EnhanceYourTrip";
import CardSlider from "../../Components/CardSlider/CardSlider";
import { routeTo } from "../../Components/CustomHooks/routeChange";
import DailyCommuter from "../../Components/HyperSales/DailyCommuter";
import { IFavouriteTrips } from "../../Orchestrator/Types/Interface/IFavouriteTrips";
import FavouriteDeparture from "../../Components/EnhanceYourTrip/FavouriteDeparture";
import { IFavoriteDeparture } from "../../Orchestrator/Types/Index";
import PopularTripsHomepage from "../../Components/EnhanceYourTrip/PopularTripsHomepage";
import { uuid } from "../../core/utils/Uuid";
import { myAccountTree } from "../../Orchestrator/ConstantTree";
import { mainAppStartupFlowExecute } from "../../Flows/MainAppPage/MainAppStartFlow";

const SearchPage: React.FC = () => {
  const intl = useIntl();
  const [isAnonymous] = useRecState<boolean>("isAnonymousStateAtom");
  const [userProfile] = useRecState<UserProfile>("userProfileStateAtom");
  const [manageIncludeWidgets] = useRecState<IManageWidgetItem[]>("manageIncludeWidgetsAtom");
  const [initialized] = useRecState<boolean>("initializedStateAtom");
  // const [requestCorporateAccountDetails] =
  //   useRecState<IRequestCorporateAccount>("requestCorporateAccountDetailsAtom");
  // const [{ selectedDates, isFilled }, setCalendarState] =
  //   useRecoilState(calendarState);
  // const [search, setSearch]: any = useRecoilState(searchState);
  // useEffect(() => {
  //   // homePageStartFlow();  
  // }, []);
  useEffect(() => {
    localStorage.removeItem("isUpgradeToPremiumFlow");
    localStorage.removeItem("isAddShuttleTransferFlow");
    localStorage.removeItem("isManageSeatingFlow");
    if (!sessionStorage.getItem("homePageExternalRef")) {
      sessionStorage.setItem("homePageExternalRef", uuid());
    }

    // updateRecoilState("subActiveAccountActionAtom", "");
    // //Reset some state on search page
    // setSearch({});
    // updateRecoilState("searchPopupDataAtom", null);
    // //Reset Manage Seating and Addons
    // updateRecoilState("isFromManageSeatingAndAddonsAtom", false);
    // // Cleanup function to reset states when component unmounts
    // return () => {
    //   if (window.location.pathname === "/search") {
    //     updateRecoilState("searchState", {
    //       from: "",
    //       fromName: "",
    //       to: "",
    //       toName: "",
    //       date: null,
    //       calc: "",
    //       passengers: {},
    //     });
    //     setCalendarState({ selectedDates: [null, null], isFilled: false });
    //     updateRecoilState("selectedRangeState", [null, null]);
    //     updateRecoilState("selectedTrainState", null);
    //     updateRecoilState("selectedInboundTrainState", null);
    //   }
    // };
    // const currentDate = new Date();
    // const prevYear = new Date();
    // const nextYear = new Date();
    // prevYear.setFullYear(currentDate.getFullYear() - 1);
    // nextYear.setFullYear(currentDate.getFullYear() + 1);
    // const params: ISearchBookingParams = {
    //   endDate: nextYear.toISOString(),
    //   startTime: prevYear.toISOString(),
    //   isBookingScreen: false,
    //   isUpcomingScreen: false,
    //   isFromHomePage: true,
    // };
    // searchBookingAction.setParams(params);
    // searchBookingAction.execute();
    updateRecoilState("isQuickExchangeStateAtom", false);
    updateRecoilState("isMultiBookingStateAtom", false);
  }, []);

  // const session = getUserProfile();
  useEffect(() => {
    let timeoutId: NodeJS.Timeout;
    if (userProfile && userProfile?.email) {
      timeoutId = setTimeout(() => {
        _eventBus.emit({
          eventName: bookItAgainTree.BookItAgainInit,
        });
        _eventBus.emit({
          eventName: bookItAgainTree.GetInterval.Get,
        });
      }, 500)
    }
    return () => clearTimeout(timeoutId);
  }, [userProfile?.email]);

  const initFiredRef = useRef(false);
  useEffect(() => {
    if (!initialized || initFiredRef.current) return;
    initFiredRef.current = true;

    const initAuth = async () => {
      try {
        // Check if the user is logging out
        const isLoggingOut = sessionStorage.getItem("isLoggingOut") === "true";

        if (
          !isLoggingOut &&
          isAnonymous &&
          window.location.pathname.includes("/search")
        ) {
          // Store current path for redirect after login
          sessionStorage.setItem(
            "redirectAfterLogin",
            window.location.pathname
          );
          // Use KeyCloakService directly for login
          await KeyCloakService.login();
          return;
        }

      } catch (error) {
        console.error("Authentication error:", error);
      } finally {
        await fetchWidgetsAction.execute();
        const includedWidgets = appStore.get(manageIncludeWidgetsAtom) || [];
        const isEnabled = (key: string) =>
          includedWidgets.some((w: IManageWidgetItem) => w.key === key);

        // favoriteDepartures widget disabled — kept commented for future re-enable.
        // if (isEnabled("favoriteDepartures")) {
        //   fetchFavouriteDeparturesBestPricesAction.execute();
        // }
        // favoriteTripsForToday widget disabled — kept commented for future re-enable.
        // if (isEnabled("favoriteTripsForToday")) {
        //   getFavouriteTripsForTodayAction.execute();
        // }
        if (isEnabled("popularTrips")) {
          getPopularTripsAction.execute();
        }
        if (isEnabled("enhanceYourTrip")) {
          getCMSEnhancedTripsAction.execute();
        }
        if (isEnabled("helpAndUsefulInformation")) {
          getCmsUsefulInformationAction.execute();
        }
      }
    };

    initAuth();
  }, [initialized, isAnonymous]);
  const [favouriteTripsForToday] = useRecState<IFavouriteTrips[]>("favouriteTripsForTodayResponseAtom");
  const [favouriteDepartures] = useRecState<IFavoriteDeparture[]>("favouriteDeparturesForTodayResponseAtom");
  return (
    <div className="main-search search-bg">
      <div className="container search-page-gap">
        <div className="search-and-slider">
          <SearchComponent
            className={"sticky_search_page"}
            isFromSearchPage={true}
          />
          <div className="main-slider">
            <div className="">
              <ImageSlider />
            </div>
          </div>
        </div>

        {manageIncludeWidgets
          .filter(
            (widget: IManageWidgetItem) =>
              // Hidden (widget cleanup): multiBooking + favoriteDepartures + favoriteTripsForToday (temporary)
              widget.key !== "multiBooking" &&
              widget.key !== "favoriteDepartures" &&
              widget.key !== "favoriteTripsForToday"
          )
          .map((widget: IManageWidgetItem) => {

          if (widget.key === "multiBooking") {
            return (
              <section key={widget.key} className="daily-commuter">
                <DailyCommuter />
              </section>
            );
          }

          // favoriteTripsForToday widget disabled — kept commented for future re-enable.
          // if (widget.key === "favoriteTripsForToday" && favouriteTripsForToday && favouriteTripsForToday.length > 0) {
          //   return (
          //     <div key={widget.key} className="favorite-today">
          //       <div className="">
          //         <Card className="favorite-trip-card" bordered={false}>
          //           <Typography.Title className="title">
          //             {intl
          //               .formatMessage({ id: "favourite_trips_of_today" })
          //               .toUpperCase()}
          //           </Typography.Title>
          //           <h6 className="sub-title mb-10">
          //             {intl.formatMessage({ id: "yourFavoriteForToday" })}
          //           </h6>
          //           <FavouriteTrips data={favouriteTripsForToday} />
          //         </Card>
          //       </div>
          //     </div>
          //   );
          // }
          if (widget.key === "enhanceYourTrip") {
            return (
              <div key={widget.key} className="enhance-trip">
                <EnhanceYourTrip />
              </div>
            );
          }
          if (widget.key === "favoriteDepartures" && favouriteDepartures && favouriteDepartures.length > 0) {
            return (
              <div key={widget.key} className="favorite-today right_image">
                <div className="">
                  <Typography.Title className="title">
                    {intl
                      .formatMessage({ id: "favourite_departures" })
                      .toUpperCase()}
                  </Typography.Title>
                  <h6 className="sub-title mb-10">
                    {intl.formatMessage({ id: "yourFavoriteDepartures" })}
                  </h6>
                  <FavouriteDeparture data={favouriteDepartures} />
                </div>
              </div>
            );
          }
          if (widget.key === "popularTrips") {
            return (
              <Section key={widget.key} type="popular_trip">
                <PopularTripsHomepage />
              </Section>
            );
          }
          if (widget.key === "helpAndUsefulInformation") {
            return (
              <Section key={widget.key} type="help_usefull">
                <HelpInfo />
              </Section>
            );
          }

          if (widget.key === "bookItAgain") {
            return (
              <section className="book-again">
                <SaleCard
                  title={intl.formatMessage({ id: "bookAgain" })}
                  description={intl.formatMessage({
                    id: "rebookWithNew",
                  })}
                />
              </section>
            );
          }
          return <></>;

        })}

        <div className="manage-widgets justify-content-center">
          <div
            className="align-items-center manage-widget"
            onClick={() => {
              mainAppStartupFlowExecute("PersonalizeExperienceFlow");
              _eventBus.emit({
                eventName: myAccountTree.MyAccount.Action.Click,
                data: "PersonalizeExperienceFlow",
              });
              updateRecoilState(
                "activeAccountActionAtom",
                "personalizeExperience"
              );
              updateRecoilState("personalizeExperienceActiveTabAtom", "2");
              routeTo("/my-account");
            }}
          >
            <div>
              <Image
                src="/assets/my_account/manage-widgets.svg"
                width={30}
                height={30}
                alt="manage widgets"
              />
            </div>
            <div className="manage-widgets-label">
              <Typography>{intl.formatMessage({ id: "manageWidgets" })}</Typography>
            </div>
          </div>
        </div>

        {/* <section className="book-again">
          <SaleCard
            title={intl.formatMessage({ id: "bookAgain" })}
            description={intl.formatMessage({
              id: "rebookWithNew",
            })}
          />
        </section>

        <Section type="popular_destinations">
          <PopularDestinationWidget />
        </Section>

        <Section type="routes">
          <RoutesWidget />
        </Section>

        <Section type="trust_builder">
          <TrustBuilderWidget />
        </Section>

        <Section type="newsletter">
          <NewsWidget />
        </Section>

        <Section type="download_app">
          <Download />
        </Section>

        <Section type="help_usefull">
          <HelpInfo />
        </Section> */}

        {/*});
          }
          if (widget.key === "favoriteTripsForToday") {
            return (
              <div key={widget.key} className="favorite-today">
                <div className="">
                  <Card className="favorite-trip-card" bordered={false}>
                    <Typography.Title className="title">
                      {intl
                        .formatMessage({ id: "favorite_trips_of_today" })
                        .toUpperCase()}
                    </Typography.Title>
                    <h6 className="sub-title mb-10">
                      {intl.formatMessage({ id: "yourFavoriteForToday" })}
                    </h6>
                    <FavouriteTrips data={trips} />
                  </Card>
                </div>
              </div>
            );
          }
          if (widget.key === "enhanceYourTrip") {
            return (
              <div key={widget.key} className="enhance-trip">
                <EnhanceYourTrip />
              </div>
            );
          }
          if (widget.key === "favoriteDepartures") {
            return (
              <div key={widget.key} className="favorite-today right_image">
                <div className="">
                  <Typography.Title className="title">
                    {intl
                      .formatMessage({ id: "favourite_departures" })
                      .toUpperCase()}
                  </Typography.Title>
                  <h6 className="sub-title mb-10">
                    {intl.formatMessage({ id: "yourFavoriteDepartures" })}
                  </h6>
                  <FavouriteTrips data={trips} isFavouriteDepartures={true} />
                </div>
              </div>
            );
          }
          if (widget.key === "popularTrips") {
            return (
              <Section key={widget.key} type="popular_trip">
                <CardSlider
                  sliderName="popularTip"
                  sliderType="popular"
                  title={intl.formatMessage({ id: "popularTripText" })}
                  subTitle={intl.formatMessage({ id: "yourPopularTripsText" })}
                />
              </Section>
            );
          }
          if (widget.key === "helpAndUsefulInformation") {
            return (
              <Section key={widget.key} type="help_usefull">
                <HelpInfo />
              </Section>
            );
          }
          return <></>;
        })}

        <div className="manage-widgets justify-content-center">
          <div
            className="align-items-center manage-widget"
            onClick={() => {
              updateRecoilState(
                "activeAccountActionAtom",
                "personalizeExperience"
              );
              updateRecoilState("personalizeExperienceActiveTabAtom", "2");
              routeTo("/my-account");
            }}
          >
            <div className="mr-10">
              <Image
                src="/assets/myAccount/manage-widgets.svg"
                width={30}
                height={30}
                alt="manage widgets"
              />
            </div>
            <div className="manage-widgets-label">
              <Typography>Manage Widgets</Typography>
            </div>
          </div>
        </div> */}
      </div>
    </div>
  );
};
export default SearchPage;
